import { Card, Empty } from 'antd';

function EmptyCard() {
    return (
        <Card>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No data available" />
        </Card>
    );
}

export default EmptyCard;